import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ecf7d10e")

_pushScopeId("data-v-ecf7d10e")
const _hoisted_1 = { class: "alpha" }
const _hoisted_2 = { class: "alpha-checkboard-wrap" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "alpha-picker" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkboard = _resolveComponent("Checkboard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Checkboard)
    ]),
    _createVNode("div", {
      class: "alpha-gradient",
      style: { background: _ctx.gradientColor }
    }, null, 4),
    _createVNode("div", {
      class: "alpha-container",
      ref: "alphaRef",
      onMousedown: _cache[1] || (_cache[1] = $event => _ctx.handleMouseDown($event))
    }, [
      _createVNode("div", {
        class: "alpha-pointer",
        style: { left: _ctx.color.a * 100 + '%' }
      }, [
        _hoisted_3
      ], 4)
    ], 544)
  ]))
})